// pusherPlugin.js
import Pusher from 'pusher-js';
import {config} from './config';

Pusher.logToConsole = true; // Optional: For debugging purposes

const pusherPlugin = {
  install(Vue) {
    Vue.prototype.$pusher = new Pusher(config.pusher_key, {
      cluster: config.pusher_cluster,
      encrypted: true
    });
  }
};

export default pusherPlugin;